import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { FormsModule } from '@angular/forms';
import { CoreModule } from 'world-archery-lib';
import { SharedModule } from '../shared/shared.module';
import { EventIndoorComponent } from './event-indoor/event-indoor.component';
import { EventListIndoorComponent } from './event-list-indoor/event-list-indoor.component';
import { FiltersIndoorComponent } from './filters-indoor/filters-indoor.component';
import { FiltersServiceService } from './filters-service.service';
import { IndoorCalendarBootstrapComponent } from './indoor-calendar-bootstrap/indoor-calendar-bootstrap.component';
import { IndoorWorldSeriesCalendarRoutingModule } from './indoor-world-series-calendar-routing.module';
import { CommonPageComponentsModule } from '../../common-page-components/common-page-components.module';

@NgModule({
  bootstrap: [IndoorCalendarBootstrapComponent],
  imports: [
    SharedModule,
    CommonModule,
    CommonPageComponentsModule,
    IndoorWorldSeriesCalendarRoutingModule,
    CoreModule,
    FormsModule
  ],
  declarations: [
    EventListIndoorComponent,
    EventIndoorComponent,
    FiltersIndoorComponent,
    IndoorCalendarBootstrapComponent
  ],
  providers: [FiltersServiceService]
})
export class IndoorWorldSeriesCalendarModule {}
